<template>
  <div class="ModelTwo">
    <div class="titleBox">
      <div class="leftPart">
        <div class="title">金牌补贴专区</div>
        <div class="tip">每日10:00上新</div>
      </div>
      <div class="moreBtnBox">
        <div class="con" @click="$router.push({ name: 'goldSubsidyZone' })">
          <span>更多</span>
          <van-icon name="arrow" class="arrow" />
        </div>
      </div>
    </div>
    <div class="scrollBox">
      <div class="modelMain status1" :class="{ status2: datalist.length === 3 }">
        <div
          class="goodsItem"
          v-for="(item, index) in datalist"
          :key="index"
          @click="tapEvent(item)"
        >
          <van-image fit="cover" class="pic" :src="item.PictUrl" />
          <div class="bottomPart">
            <div class="title twoRow">
              {{ item.Title }}
            </div>

            <div class="subBottom">
              <div class="tagBox">
                <div class="tag" v-if="item.TljAmount">
                  <div class="label">补贴</div>
                  <div class="price">{{ item.TljAmount }}元</div>
                </div>
              </div>
              <div class="priceBox">
                <i class="symbol">￥</i>
                <span class="price">{{ item.CouponFinalPrice }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { Icon, Image as VanImage } from "vant";
export default {
  name: "ModelTwo",
  components: {
    VanImage,
    "van-icon": Icon,
  },
  props: {
    datalist: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    ...mapMutations(["SET_GOODS_DETAIL_DATA"]),
    tapEvent(item) {
      this.SET_GOODS_DETAIL_DATA(item);
      this.$emit("entotTLJDetailPage", item.NumIID);
    },
  },
};
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.ModelTwo {
  width: 96%;
  background: linear-gradient(
    127deg,
    #ffeed5 8%,
    rgba(254, 243, 226, 0.6) 47%,
    rgba(254, 246, 236, 0.8) 97%
  );
  border-radius: vw(8);
  margin: 0 auto 0;
  padding: 0 0 vw(10);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .titleBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 vw(10);
    box-sizing: border-box;
    width: 100%;
    // margin-bottom: vw(9);
    .leftPart {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: vw(10) 0;
      .title {
        position: relative;
        font-size: vw(15);
        font-weight: 700;
        color: #e18f22;
        padding-right: vw(6);
        &::before {
          position: absolute;
          right: 0;
          top: 50%;
          width: vw(1);
          height: vw(10);
          background-color: #e18f22;
          content: "";
          transform: translateY(-50%);
        }
      }
      .tip {
        font-size: vw(13);
        font-weight: 400;
        color: #e18f22;
        padding-left: vw(6);
      }
    }
    .moreBtnBox {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: vw(21);
      opacity: 1;
      border: 1px solid #e18f22;
      border-radius: vw(12);
      font-size: vw(12);
      color: #e18f22;
      box-sizing: border-box;
      padding: 0 vw(4) 0 vw(9);
      .con {
        display: flex;
        align-items: center;
      }
    }
  }
  .modelMain {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    .goodsItem {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex-shrink: 0;
      width: vw(105);
      height: vw(198);
      opacity: 1;
      background: #ffffff;
      margin-left: vw(10);
      border-radius: vw(4);
      overflow: hidden;
      .pic {
        width: vw(105);
        height: vw(105);
      }
      .bottomPart {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        padding: 4px 4px;
        .title {
          font-size: vw(13);
          font-weight: 400;
          // background-color: pink;
          margin-bottom: vw(8);
        }
        .tagBox {
          display: flex;
          align-items: center;
          font-size: vw(11);
          margin-bottom: vw(4);
          .tag {
            display: flex;
            align-items: center;
            border-radius: vw(2);
            overflow: hidden;
            .label {
              background-color: #ec0536;
              color: #fff;
              min-width: vw(28);
              text-align: center;
            }
            .price {
              color: #ec0536;
              background-color: #fbf3c9;
              min-width: vw(20);
              text-align: center;
              padding: 0 vw(4);
            }
          }
        }
        .priceBox {
          color: #f23030;
          font-size: vw(16);
          .symbol {
            font-size: vw(11);
            font-style: normal;
          }
        }
      }
    }
    .goodsItem:last-child {
      margin-right: vw(10);
    }
    &.status1 {
      width: max-content; /*配合外层div解决最后一个子元素设置margin-right无效 */
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
    }
    &.status2 {
      justify-content: space-between;
      width: 100%;
      margin: 0 vw(10);
      .goodsItem {
        margin-left: 0;
      }
      .goodsItem:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>